module.exports = __webpack_public_path__ + "media/assets/commonsense-de9f842d0c747790c4c3364879f9a694.png";